import { ReactElement } from 'react';

import Footer from '@/layout/footer/footer';
import Header from '@/layout/header/header';

import s from './main-layout.module.scss';
import dynamic from 'next/dynamic';
import { useCookies } from '@/hooks/common/use-cookies';
import { useStatistics } from '@/hooks/common/use-statistics';
import { useInView } from 'react-intersection-observer';

const Cookies = dynamic(() => import('@/ui/cookies/cookies'), {
  ssr: false,
});

const MainLayout = ({
  children,
  lazyFooter = false,
  isCheckPage = false,
}: {
  children: ReactElement;
  lazyFooter: boolean;
  isCheckPage: boolean;
}) => {
  useStatistics();

  const { shouldCookiesDisplay, closeCookies } = useCookies();
  const { ref, inView } = useInView({
    threshold: 1,
    triggerOnce: true,
    rootMargin: '0px 0px 392px 0px',
  });

  return (
    <>
      <Header isCheckPage={isCheckPage} />

      <main className={s.content}>{children}</main>

      {shouldCookiesDisplay && <Cookies closeCookies={closeCookies} />}

      {lazyFooter ? <div ref={ref}>{inView && <Footer />}</div> : <Footer />}
    </>
  );
};

export default MainLayout;
